import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Agregator Name', value: 'aggregator_name' },
  { text: 'Merchant Name', value: 'merchant_name'},
  { text: 'MID', value: 'mid'},
  { text: 'Transaction Type', value: 'jenis_trx' },
  { text: 'Issuer Name', value: 'issuer_name' },
  { text: 'Customer PAN', value: 'customer_pan'},
  { text: 'Acquirer Name', value: 'acquirer_name'},
  { text: 'Amount', value: 'amount'},
  { text: 'MDR', value: 'mdr_fee'},
  { text: 'Net Amount', value: 'net_amount'},
  { text: 'Transaction Date', value: 'trx_date'},
  { text: 'Status', value: 'status'},
  { text: 'Settlement Status', value: 'settlement_status'},
  { text: 'Source of Fund', value: 'sof'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {
  aggregator_name: '',
  merchant_name: '',
  mid: '',
  jenis_trx: '',
  sof: '',
  trx_date: [],
};

export const editedItem = {
  aggregator_name: '',
  merchant_name: '',
  mid: '',
  jenis_trx: '',
  card_no: '',
  amount: '',
  mdr_fee: '',
  net_amount: '',
  trx_date: '',
  sof: '',
  proc_date: '',
  gb: '',
  ob: '',
  seq: '',
  type: '',
  payment_date: '',
  auth: '',
  tid: '',
  ptr: '',
  rate: '',
  disc_amount: '',
  air_fare: '',
  plan: '',
  ss_amount: '',
  ss_fee_type: '',
  flag: '',
  merchant_account: '',
};
